// src/data/quiz-library/index.js
//
// Slug-keyed lookup into the shared quiz library. State-agnostic on purpose.

import quizLibrary from "./quizLibrary";

// Slugs drift between the topics files and the quiz files — "africa-features"
// against "africafeatures" — so matching happens on a stripped form too.
const strip = (v = "") => String(v).toLowerCase().replace(/[^a-z0-9]/g, "");

const STRIPPED = Object.keys(quizLibrary).reduce((acc, slug) => {
  acc[strip(slug)] = slug;
  return acc;
}, {});

export const getQuizBySlug = (slug) => {
  if (!slug) return null;
  return quizLibrary[slug] || quizLibrary[STRIPPED[strip(slug)]] || null;
};

export const hasQuiz = (slug) => !!getQuizBySlug(slug);

export const quizSlugs = () => Object.keys(quizLibrary);

export { quizLibrary };
export default quizLibrary;
